import { toast as hotToast, type ToastOptions } from 'react-hot-toast';
import { isAuthError } from './errors';

// Re-export Toaster primitives so __root.tsx (the one legitimate call site that renders
// the Toaster) doesn't need to import directly from react-hot-toast.
export { Toaster, ToastBar, useToaster } from 'react-hot-toast';

const defaults: ToastOptions = { duration: 4000 };

export const toast = {
  success: (message: string, options?: ToastOptions) =>
    hotToast.success(message, { ...defaults, ...options }),
  error: (message: string, options?: ToastOptions) =>
    hotToast.error(message, { ...defaults, ...options }),
};

/**
 * Mutation/query `onError` toast. Skips auth errors (expired/missing token) —
 * those are a session-expiry redirect, not a user-actionable failure, and
 * `useSessionExpiry` already sends the user to /login; a generic "failed,
 * please try again" toast alongside that redirect is just misleading noise.
 */
export function showMutationErrorToast(error: unknown, message: string): void {
  if (isAuthError(error)) return;
  toast.error(message);
}
